import {
  DefaultMissingHandler,
  TranslocoConfig,
  TranslocoMissingHandler
} from '@jsverse/transloco';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomTranslocoMissingHandler
  extends DefaultMissingHandler
  implements TranslocoMissingHandler
{
  override handle(key: string, config: TranslocoConfig) {
    if (config.prodMode) {
      return super.handle(key, config);
    } else {
      console.warn('Missing translation', key);
      return key;
    }
  }
}
